import React from "react";
import CustomTooltip from "app/common/TooltipComponent";
import { IconButton, Typography, Tooltip } from "@material-ui/core";

/* eslint-disable react/prop-types */
const CannibalizationTooltipComponent = ({
  placement,
  iconComponent,
  isCustomTooltip = true,
}) => {
  const MyTooltip = ({ title, children }) => {
    if (isCustomTooltip) {
      return (
        <CustomTooltip placement={placement} title={title}>
          {children}
        </CustomTooltip>
      );
    }
    return (
      <Tooltip placement={placement} title={title}>
        {children}
      </Tooltip>
    );
  };

  return (
    <MyTooltip
      title={
        <Typography
          style={{
            fontSize: "12px",
          }}
        >
          <p>
            See how volume is distributed when there&apos;s an increase or
            decrease in product prices.
          </p>
          <p>
            Review how your volume is affected by changes in product prices.
          </p>
          <p>
            Cannibalization can occur within the same or different products,
            retailers, and channels.
          </p>
          <p>
            Please note that, when applied, the scenario will freeze to avoid
            miscalculations.
          </p>
        </Typography>
      }
    >
      <IconButton size="small" aria-label="delete">
        {iconComponent}
      </IconButton>
    </MyTooltip>
  );
};

export default CannibalizationTooltipComponent;
